import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/config/cookie'
import GLOBAL_VAR from '~/utils/global'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 用户的页面
  {
    path: '/',
    component: () => import('../views/index'),
    redirect: '/paper-submit',
    meta: {
      authentication: true
    },
    children: [
      // 提交稿件
      {
        path: 'paper-submit',
        component: () => import('../views/index/paper-submit'),
        meta: {
          sidebar: '/paper-submit'
        }
      },
      // 我的稿件
      {
        path: 'my-paper',
        component: () => import('../views/index/my-paper'),
        meta: {
          sidebar: '/my-paper'
        }
      },
      // 我的稿件 -> 详情
      {
        path: 'paper-detail',
        component: () => import('../views/index/paper-detail'),
        meta: {
          sidebar: '/my-paper'
        }
      },
      // 编辑证明下载
      {
        path: 'certificate',
        component: () => import('../views/index/certificate'),
        meta: {
          sidebar: '/certificate'
        }
      }
    ]
  },
  // 登录
  {
    path: '/login',
    component: () => import('../views/login')
  },
  // 个人信息
  {
    path: '/userinfo',
    component: () => import('../views/userinfo'),
    meta: {
      authentication: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  bar.start()

  if (to.matched.some(record => record.meta.authentication)) {
    let token = cookie.get('en_token')
    let userinfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (token && userinfo.role === GLOBAL_VAR.ROLE_0) {
      next()
    } else {
      // 无token无权限
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js